"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEntityProperty = void 0;
/**
 * React-based property management hook for Confluence API and entities
 */
const react_1 = require("react");
// outputs a stateful variable and a function to update it
const useEntityProperty = ({ entityManager, defaultRetryCount = 2 }) => {
    const [propValue, setPropValue] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const getProp = async () => {
            const currentVal = await entityManager.get();
            setPropValue(currentVal);
        };
        getProp().catch(() => {
            // repeat fetch in case previous creation failed due to variable already concurrently created
            getProp().catch((secondErr) => {
                throw secondErr;
            });
        });
    }, []);
    const updateProp = (0, react_1.useCallback)(async (valueUpdate, retryCount = defaultRetryCount) => {
        let success = false;
        let tryCounts = 0;
        const attempt = async () => setPropValue(await entityManager.update(valueUpdate));
        // initial update attempt + up to <retryCount> retries if update unsuccessful
        while (!success && tryCounts <= retryCount) {
            try {
                tryCounts++;
                await attempt();
                success = true;
            }
            catch (err) {
                if (tryCounts > retryCount) {
                    console.error(err); // eslint-disable-line no-console
                }
            }
        }
    }, [entityManager]);
    const deleteProp = (0, react_1.useCallback)(async () => {
        await entityManager.delete();
        setPropValue(undefined);
    }, [entityManager]);
    return [propValue, updateProp, deleteProp];
};
exports.useEntityProperty = useEntityProperty;
